import sourceMapSupport from 'source-map-support/browser-source-map-support.js';
if (sourceMapSupport && sourceMapSupport.install) {
    sourceMapSupport.install();
} else if (sourceMapSupport && sourceMapSupport.sourceMapSupport) {
    sourceMapSupport.sourceMapSupport.install();
} else if (window.sourceMapSupport) {
    window.sourceMapSupport.install();
}

/* global DIAGNOSTIC_TOOL */
if (DIAGNOSTIC_TOOL) {
  import('./errors.js');
}
import { calendar_loader_show, calendar_loader_hide } from "./calendar.js";
window.calendar_loader_show = calendar_loader_show;
window.calendar_loader_hide = calendar_loader_hide;
import { clean_explorer_timeline, change_event_timezone, make_explore_timeline } from "./calendar.js";
window.clean_explorer_timeline = clean_explorer_timeline;
window.change_event_timezone = change_event_timezone;
window.make_explore_timeline = make_explore_timeline;

import { 
  downloadCSV, 
  downloadCSV_classic, 
  createSummaryTable_classic, 
  download_dataexplorer_csv, 
  download_dataexplorer_from_datasource_csv, 
  download_dataexplorer_div 
} from './export.js';
import { monitorRequestAndPoll } from './polling.js';
import { renderScheduleEventUI, renderResourceUI, renderDayUI } from './ui.js';
import { state, updateState, syncServerRenderedState } from './state.js';
import { installSwanbotRelayTransport } from './swanbot_relay.js';
import { observeAgentsPage } from './agents_page.js';
import { waitForElm, waitForElmDel, recreateNode, fivedigit } from './utils.js';
import { clientside } from './clientside.js';
import './dataexplorer_lock.js';
import {
  initDataExplorerTabs,
  getDataExplorerOpenTabCount,
  getDataExplorerOpenTabsSnapshot,
  isCurrentDataExplorerTabTracked,
  DATAEXPLORER_TABS_EVENT_NAME
} from './dataexplorer_tabs.js';
import {
  load_explorer_swanbot_key,
  sendMessage,
  fetchEvents,
  fetchSlackChannels,
  fetchSlackUsers,
  watchSettings,
  fetchEventDetails,
  fetchApiData,
  fetchAuthData,
  fetchEventCategories,
  sendCommentAction,
  executeDynamicAction
} from './api.js';
import {
  setAllHoverTemplates,
  restoreAllOriginalTemplates,
  create_dataexplorer_graph,
  draw_date_row_events,
  draw_date_row
} from './charts.js';

import {
  ready_swanbot,
  closeswanbot,
  showswanbot,
  swanbot_input_init,
  dataexplorer_swanbot_input_init,
  clean_swanbot_chat,
  clean_dataexplorer_swanbot_chat,
  get_swanbot_data,
  get_swanbot_graphs,
  get_dataexplorer_swanbot_stop,
  reset_swanbot_end,
  get_dataexplorer_swanbot_data,
  load_explorer_swanbot_endpoint,
  load_explorer_swanbot_agents,
  load_explorer_swanbot_agent_detail,
  create_dataexplorer_agent,
  clone_dataexplorer_agent,
  delete_dataexplorer_agent,
  run_dataexplorer_agent,
  update_dataexplorer_agent_run_state,
  load_explorer_swanbot,
  load_swanbot_dataexplorer_compare,
  load_swanbot_dataexplorer_compare_graphData,
  swanbot_load_subgroup,
  swanbot_toggle_graphgroup,
  swanbot_input_disabled,
  swanbot_input_enabled,
  swanbot_dataexplorer_input_disabled,
  swanbot_dataexplorer_input_enabled
} from './swanbot.js';

window.WingmanState = state;
syncServerRenderedState();
installSwanbotRelayTransport();
observeAgentsPage();
initDataExplorerTabs();
window.updateState = updateState;
window.waitForElm = waitForElm;
window.fivedigit = fivedigit;
window.waitForElmDel = waitForElmDel;
window.recreateNode = recreateNode;
window.getDataExplorerOpenTabCount = getDataExplorerOpenTabCount;
window.getDataExplorerOpenTabsSnapshot = getDataExplorerOpenTabsSnapshot;
window.isCurrentDataExplorerTabTracked = isCurrentDataExplorerTabTracked;
window.WingmanDataExplorerTabs = {
  init: initDataExplorerTabs,
  getCount: getDataExplorerOpenTabCount,
  getSnapshot: getDataExplorerOpenTabsSnapshot,
  isTracked: isCurrentDataExplorerTabTracked,
  eventName: DATAEXPLORER_TABS_EVENT_NAME
};

window.load_explorer_swanbot_key = load_explorer_swanbot_key;
window.sendMessageAPI = sendMessage;
window.fetchEventsAPI = fetchEvents;
window.fetchSlackChannelsAPI = fetchSlackChannels;
window.fetchSlackUsersAPI = fetchSlackUsers;
window.watchSettingsAPI = watchSettings;
window.fetchEventDetailsAPI = fetchEventDetails;
window.fetchApiDataAPI = fetchApiData;
window.fetchAuthDataAPI = fetchAuthData;
window.fetchEventCategoriesAPI = fetchEventCategories;
window.sendCommentActionAPI = sendCommentAction;
window.executeDynamicActionAPI = executeDynamicAction;

window.setAllHoverTemplates = setAllHoverTemplates;
window.restoreAllOriginalTemplates = restoreAllOriginalTemplates;
window.create_dataexplorer_graph = create_dataexplorer_graph;
window.draw_date_row_events = draw_date_row_events;
window.draw_date_row = draw_date_row;

window.renderScheduleEventUI = renderScheduleEventUI;
window.renderResourceUI = renderResourceUI;
window.renderDayUI = renderDayUI;

window.ready_swanbot = ready_swanbot;
window.closeswanbot = closeswanbot;
window.showswanbot = showswanbot;
window.swanbot_input_init = swanbot_input_init;
window.dataexplorer_swanbot_input_init = dataexplorer_swanbot_input_init;
window.clean_swanbot_chat = clean_swanbot_chat;
window.clean_dataexplorer_swanbot_chat = clean_dataexplorer_swanbot_chat;
window.get_swanbot_data = get_swanbot_data;
window.get_swanbot_graphs = get_swanbot_graphs;
window.get_dataexplorer_swanbot_stop = get_dataexplorer_swanbot_stop;
window.reset_swanbot_end = reset_swanbot_end;
window.get_dataexplorer_swanbot_data = get_dataexplorer_swanbot_data;
window.load_explorer_swanbot_endpoint = load_explorer_swanbot_endpoint;
window.load_explorer_swanbot_agents = load_explorer_swanbot_agents;
window.load_explorer_swanbot_agent_detail = load_explorer_swanbot_agent_detail;
window.create_dataexplorer_agent = create_dataexplorer_agent;
window.clone_dataexplorer_agent = clone_dataexplorer_agent;
window.delete_dataexplorer_agent = delete_dataexplorer_agent;
window.run_dataexplorer_agent = run_dataexplorer_agent;
window.update_dataexplorer_agent_run_state = update_dataexplorer_agent_run_state;
window.load_explorer_swanbot = load_explorer_swanbot;
window.load_swanbot_dataexplorer_compare = load_swanbot_dataexplorer_compare;
window.load_swanbot_dataexplorer_compare_graphData = load_swanbot_dataexplorer_compare_graphData;
window.swanbot_load_subgroup = swanbot_load_subgroup;
window.swanbot_toggle_graphgroup = swanbot_toggle_graphgroup;
window.swanbot_input_disabled = swanbot_input_disabled;
window.swanbot_input_enabled = swanbot_input_enabled;
window.swanbot_dataexplorer_input_disabled = swanbot_dataexplorer_input_disabled;
window.swanbot_dataexplorer_input_enabled = swanbot_dataexplorer_input_enabled;

if (!window.dash_clientside) { window.dash_clientside = {}; }

window.dash_clientside.clientside = clientside;


window.downloadCSV = downloadCSV;
window.downloadCSV_classic = downloadCSV_classic;
window.createSummaryTable_classic = createSummaryTable_classic;
window.download_dataexplorer_csv = download_dataexplorer_csv;
window.download_dataexplorer_from_datasource_csv = download_dataexplorer_from_datasource_csv;
window.download_dataexplorer_div = download_dataexplorer_div;

window.monitorRequestAndPoll = monitorRequestAndPoll;

import './legacy_events.js';
